import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { RotaSummary } from '../../../models/rota/RotaSummary';
import { RotaSummaryResponse } from '../../../../interfaces/response/RotaResponses';

/**
 * An adapter converts rota summary HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class RotaSummaryAdapter implements Adapter<RotaSummary> {

  /**
   * Converts rota summary HTTP response to {@link RotaSummary}.
   * @param item rota summary HTTP response.
   */
  adapt(item: RotaSummaryResponse): RotaSummary {
    return new RotaSummary(item.date);
  }
}
